import Main from '@/views/administracion/configuracion/catalogos/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/Default.vue';
import Entidades from './entidades';
import Municipios from './municipios';
import Contratistas from './contratistas';
import Deducciones from './deducciones';
import Funcionarios from './funcionarios';
import Usuarios from './usuarios';
import FuentesFinancieras from './fuentesfinancieras';
import ProgramasInversion from './programasinversion';
import TiposObra from './tiposobra';
import SubTiposObra from './subtiposobra';
import Etiquetas from './etiquetas';
import ContratosEstatus from './contratosestatus';
import Expedientes from './expedientes';
import EntesFiscalizadores from './entesfiscalizadores';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const catalogos = [
  {
    path: 'catalogos',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogos',
        path: '/',
        meta: {
          title: 'Catálogos',
          auth,
          scopes,
        },
        component: Default,
        children: [
          ...Entidades,
          ...Municipios,
          ...Contratistas,
          ...Deducciones,
          ...Funcionarios,
          ...Usuarios,
          ...FuentesFinancieras,
          ...ProgramasInversion,
          ...TiposObra,
          ...SubTiposObra,
          ...Etiquetas,
          ...ContratosEstatus,
          ...Expedientes,
          ...EntesFiscalizadores,
          {
            name: 'CatalogoSubprogramasView',
            path: 'subprogramas',
            meta: {
              title: 'Subprogramas',
              auth,
              scopes,
            },
            component: () => import('@/views/administracion/configuracion/catalogos/subprogramas/CatalogoSubprogramasView.vue'),
          },
          {
            name: 'CatalogoColoniasView',
            path: 'colonias',
            meta: {
              title: 'Colonias',
              auth,
              scopes,
            },
            component: () => import('@/views/administracion/configuracion/catalogos/colonias/CatalogoColoniasView.vue'),
          },
          {
            name: 'CatalogoPartidasContablesView',
            path: 'partidas-contables',
            meta: {
              title: 'Partidas Contables',
              auth,
              scopes,
            },
            component: () => import('@/views/administracion/configuracion/catalogos/partidas.contables/CatalogoPartidasContablesView.vue'),
          },
          {
            name: 'CatalogoGruposObrasView',
            path: 'grupos-obras',
            meta: {
              title: 'Grupos de Obras',
              auth,
              scopes,
            },
            component: () => import('@/views/administracion/configuracion/catalogos/grupos.obras/CatalogoGruposObrasView.vue'),
          },
          {
            name: 'CatalogoSubgruposObrasView',
            path: 'subgrupos-obras',
            meta: {
              title: 'Subgrupos de Obras',
              auth,
              scopes,
            },
            component: () => import('@/views/administracion/configuracion/catalogos/subgrupos.obras/CatalogoSubgruposObrasView.vue'),
          },
          {
            name: 'CatalogoLocalidadesView',
            path: 'localidades',
            meta: {
              title: 'Localidades',
              auth,
              scopes,
            },
            component: () => import('@/views/administracion/configuracion/catalogos/localidades/CatalogoLocalidadesView.vue'),
          },
          {
            name: 'CatalogoContratosEventosView',
            path: 'contratos-eventos',
            meta: {
              title: 'Contratos Eventos',
              auth,
              scopes,
            },
            component: () => import('@/views/administracion/configuracion/catalogos/contratos.eventos/CatalogoContratosEventosView.vue'),
          },
        ],
      },
    ],
  },
];

export default catalogos;
